const sanitizeRegEx = /([()[{*+.$^\\|?])/g;

/**
 * Method to Sanitize and Prep Search Term for Regex
 * @param searchTerm [string] The variable used to pass the search term to be sanitized.
 * @returns searchTerm [string] Sanitized Search Search Term.
 */
export const sanitizeSearchTerm = (searchTerm) => {
  if (searchTerm) {
    searchTerm = searchTerm.replace(sanitizeRegEx, '\\$1');
  }

  return searchTerm;
};

/**
 * Method to Emphasize the Search Term in the Event List.
 * @param suggestionString [string] The variable used to pass the search term to be sanitized.
 * @param term [string] the variable containing the substring that has to be emphasized.
 * @returns emphasizedSuggestionString [string] Sanitized Search Search Term.
 */
export const emphasizeSearchTerm = (suggestionString, term) => {
  const reg = RegExp(sanitizeSearchTerm(term), 'ig');

  return suggestionString.replace(reg, '<span class="SearchSuggestionListItem__term--em">$&</span>');
};
